import React from "react";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { firm } from "../../data/site";
import { refinedMedia } from "../../data/refinedMedia";
import { CaseReviewForm } from "../form/CaseReviewForm";
export function Hero({
  showReviewNotes
}: {
  showReviewNotes: boolean;
}) {
  return <section aria-labelledby="hero-title" className="bold-hero on-dark" data-id="element-206" data-mp="eqx1fd4wgyr5">
      <img className="hero-background" src={refinedMedia.hero.src} srcSet={refinedMedia.hero.srcSet} sizes="100vw" width={1600} height={513} alt="" loading="eager" fetchPriority="high" decoding="async" data-id="element-207" data-mp="aoa6h3cxmxpq" />
      <div className="hero-shade" aria-hidden="true" data-id="element-208" data-mp="q482vqc49pm" />
      <div className="page-container hero-grid" data-id="element-209" data-mp="qm905nxzc3v">
        <div className="hero-heading" data-id="element-210" data-mp="3rx6u78rbfpsz">
          <p className="eyebrow text-white" data-id="element-211" data-mp="3ry8bhuyxd8j5">The Motorcycle Lawyer®</p>
          <h1 id="hero-title" data-id="element-212" data-mp="1v3c42qq1qrcu">Michigan Motorcycle Accident Lawyer</h1>
        </div>
        <div id="case-review" tabIndex={-1} className="hero-form" data-id="element-213" data-mp="1q4sjour3pnml">
          <CaseReviewForm showReviewNotes={showReviewNotes} data-id="element-214" data-mp="1q3hfittquduy" />
        </div>
        <div className="hero-supporting" data-id="element-215" data-mp="1mv194eviihaq">
          <h2 data-id="element-216" data-mp="1rvyokjp50x8j">A serious crash deserves serious representation.</h2>
          <p data-id="element-217" data-mp="1rtckiu1ggzv2">Jason Waechter and his team represent injured riders and families across Michigan. Get a free review of your motorcycle crash.</p>
          <a href={firm.phoneHref} className="hero-phone" data-id="element-218" data-mp="1hwg84d8frtl8"><PhoneIcon aria-hidden="true" size={26} data-id="element-219" data-mp="1hzc5o0gdgg95" /> Call {firm.phoneDisplay}</a>
          <a href="#case-result" className="hero-proof" data-id="element-220" data-mp="25nc5dpvnvgzv">See the $27.5 million jury verdict <ArrowRightIcon aria-hidden="true" size={20} data-id="element-221" data-mp="2akvkes06nxsv" /></a>
        </div>
      </div>
    </section>;
}